import { render, staticRenderFns } from "./GoogleLogin.vue?vue&type=template&id=3594700a&scoped=true"
import script from "./GoogleLogin.vue?vue&type=script&lang=js"
export * from "./GoogleLogin.vue?vue&type=script&lang=js"
import style0 from "./GoogleLogin.vue?vue&type=style&index=0&id=3594700a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3594700a",
  null
  
)

export default component.exports